import PagedList from '../../commons/pagedList'
import { adminHttpClient } from '../../commons/adminHttpClient'

export interface PagedExpensesToReview extends PagedList<ExpenseForReview> {}

export interface ExpenseForReview {
  expenseId: string
  companyUser: CompanyUser
  expenseType: ExpenseType
  requestedAmount: number
  purchasedDate: Date
  dateSubmitted: Date
  serviceProvider: string
  expenseNumber: number
  hraDeductibleAmount: number
  costSharingAmount: number
  status: number
  lockedBy: CompanyUser | null
  resubmitted: Boolean
}

export interface CompanyUser {
  id: string
  name: string
}

interface ExpenseType {
  id: String
  name: string
}

export type ExpenseForReviewFilter = {
  pageNumber: number
  productId?: number
  onlyInternalCompanies?: boolean
  expenseTypeId?: number
}

const getExpensesForReview = (filter: ExpenseForReviewFilter): Promise<PagedList<ExpenseForReview>> => {
  return adminHttpClient.get('/DocReview/ExpensesForReview', filter)
}

export default getExpensesForReview
